import React, { Component } from 'react';
import CloudUpload from '@mui/icons-material/CloudUpload';
import {
  attachFile
} from '@lba-dev/package.local-globals/utils';
import {
  data as certificatTypes
} from '@lba-dev/package.local-globals/certificatTypes';
import Typography from '@mui/material/Typography';
import Button from '@mui/material/Button';
import { grey, green, red, orange } from '@mui/material/colors';
import {
  CERT_PENDING,
  CERT_VALID,
  CERT_INVALID
} from '@lba-dev/package.local-globals/certificatStatus';

import FilesTable from '../Utils/filesTable';
import notifSystem from '../../notifSystem';
import { uploadCertificat } from '../../actions/certificat';
import { closeDialog } from '../../actions/dialog';
import store from '../../store';

const path = ['certificats'];

class CertificatUploadButton extends Component {
  uploadFunction = async (e) => {
    const {
      setData,
      interventionId,
      certificats,
      certificatType
    } = this.props;
    const files = e.target.files;
    const certInfo = certificatTypes.find(c => c._id === certificatType);

    if (!files.length) {
      return;
    }

    try {
      const { data, name } = await attachFile(files[0]);
      const res = await uploadCertificat(interventionId, {
        file: data,
        fileName: name,
        certificatType,
      });

      const link = res.body().data().link;
      const updatedCertificats = certificats.map(cert => {
        if (cert.get('type') === certificatType) {
          return cert.merge({
            link,
            fileName: name,
            uploadDate: new Date().toISOString(),
            status: CERT_PENDING
          });
        }
        return cert;
      });

      setData(path, updatedCertificats);

      notifSystem.success(
        'Succès',
        `${certInfo?.name || 'Certificat'} envoyé avec succès`
      );

      store.dispatch(closeDialog());
    } catch {
      notifSystem.error(
        'Erreur',
        'Le certificat n\'a pas été téléchargé'
      );
    } finally {
      e.target.value = '';
    }
  };

  getStatusColor = (status, isUploaded) => {
    switch (status) {
      case CERT_VALID:
        return green[500];
      case CERT_INVALID:
        return red[500];
      case CERT_PENDING:
        return isUploaded ? orange[500] : red[500];
      default:
        return red[500];
    }
  };

  getButtonText = (isUploaded, status, title, certInfo) => {
    if (isUploaded && status === CERT_VALID) {
      return 'Certificat validé';
    }
    if (isUploaded && status === CERT_PENDING) {
      return 'En attente de validation';
    }
    if (isUploaded && status === CERT_INVALID) {
      return 'Remplacer le certificat';
    }
    return title || certInfo?.name || 'Ajouter un certificat';
  };

  render() {
    const {
      certificats,
      certificatType,
      title
    } = this.props;

    const cert = certificats.find(c => c.get('type') === certificatType);
    const isUploaded = cert && cert.get('fileName');
    const status = cert ? cert.get('status') : CERT_PENDING;
    const statusColor = this.getStatusColor(status, isUploaded);
    const certInfo = certificatTypes.find(c => c._id === certificatType);
    const buttonText = this.getButtonText(isUploaded, status, title, certInfo);

    return (
      <div>
        <input
          disabled={isUploaded && status === CERT_VALID}
          type="file"
          id={`certificat-${certificatType}`}
          style={{ display: 'none' }}
          accept="image/*,.pdf"
          onChange={this.uploadFunction}
        />
        <label htmlFor={`certificat-${certificatType}`}>
          <Button
            disabled={isUploaded && status === CERT_VALID}
            fullWidth
            variant="contained"
            component="span"
            color="primary"
            style={{ backgroundColor: statusColor }}
          >
            <Typography
              variant="body1"
              style={{
                color: grey[50],
                textAlign: 'center',
              }}
            >
              {buttonText}
            </Typography>
            <CloudUpload />
          </Button>
        </label>
        {certInfo && (
          <Typography
            variant="caption"
            display="block"
            style={{ marginTop: 8, color: grey[600] }}
          >
            {certInfo.description}
          </Typography>
        )}
        {isUploaded && (
          <FilesTable
            fileType={certificatType}
            body={[{
              fileName: cert.get('fileName'),
              link: cert.get('link'),
              type: certificatType,
              uploadDate: cert.get('uploadDate')
            }]}
            checkDocumentNumber={() => 1}
          />
        )}
      </div>
    );
  }
}

export default CertificatUploadButton;
